import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = (params) => {
    return network.post('api/bo/management/updateProject', params).then((response) => {
        return response.data;
    });
};
export const useMutationRenameProject = () => {
    return useMutation<any, QueryError, IRenameProject>({ mutationFn: (params) => mutationFn(params) });
};

interface IRenameProject {
    projectId: number;
    projectName: string;
}
